export enum apiUrlEvents {
    EVENTS = '/v1/events/',
    EVENTS_LEVEL_TWO = '/v1/events-level2/',
    EVENTS_LEVEL_THREE = '/v1/events-level3/',
    UPLOAD_EVENTS = '/v1/import-events/',
}
